module.exports = __webpack_public_path__ + "static/img/IMG_20160925_181050.c3f7abe1.jpg";